
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, anonRecord_type, int32_type, list_type, string_type, record_type, class_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export function AvailabilityFactor__ToI18nString(this$) {
    switch (this$) {
        case "maintenance":
            return "availability.factor_maintenance";
        case "reservation":
            return "availability.factor_reservation";
        default:
            return "availability.factor_assignment";
    }
}

export function AvailabilityStatus__ToI18nString(this$) {
    switch (this$) {
        case "partiallyAvailable":
            return "availability.status_partially_available";
        case "unavailable":
            return "availability.status_unavailable";
        default:
            return "availability.status_available";
    }
}

export class AvailabilityPeriod extends Record {
    constructor(StartDate, EndDate) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
    }
}

export function AvailabilityPeriod_$reflection() {
    return record_type("Shared.Availability.AvailabilityPeriod", [], AvailabilityPeriod, () => [["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")]]);
}

export class AvailabilityBlock extends Record {
    constructor(Factor, StartDate, EndDate, Description) {
        super();
        this.Factor = Factor;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Description = Description;
    }
}

export function AvailabilityBlock_$reflection() {
    return record_type("Shared.Availability.AvailabilityBlock", [], AvailabilityBlock, () => [["Factor", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["Description", string_type]]);
}

export class ToolAvailabilityDto extends Record {
    constructor(ToolId, DisplayName, InventoryNumber, StorageName, Status, Blocks, AvailablePeriods, AvailableDays, TotalDays) {
        super();
        this.ToolId = ToolId;
        this.DisplayName = DisplayName;
        this.InventoryNumber = InventoryNumber;
        this.StorageName = StorageName;
        this.Status = Status;
        this.Blocks = Blocks;
        this.AvailablePeriods = AvailablePeriods;
        this.AvailableDays = (AvailableDays | 0);
        this.TotalDays = (TotalDays | 0);
    }
}

export function ToolAvailabilityDto_$reflection() {
    return record_type("Shared.Availability.ToolAvailabilityDto", [], ToolAvailabilityDto, () => [["ToolId", string_type], ["DisplayName", string_type], ["InventoryNumber", string_type], ["StorageName", string_type], ["Status", string_type], ["Blocks", list_type(AvailabilityBlock_$reflection())], ["AvailablePeriods", list_type(AvailabilityPeriod_$reflection())], ["AvailableDays", int32_type], ["TotalDays", int32_type]]);
}

export class CategoryAvailabilityDto extends Record {
    constructor(Categories, StartDate, EndDate, Tools, AvailableCount, PartiallyAvailableCount, UnavailableCount) {
        super();
        this.Categories = Categories;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Tools = Tools;
        this.AvailableCount = (AvailableCount | 0);
        this.PartiallyAvailableCount = (PartiallyAvailableCount | 0);
        this.UnavailableCount = (UnavailableCount | 0);
    }
}

export function CategoryAvailabilityDto_$reflection() {
    return record_type("Shared.Availability.CategoryAvailabilityDto", [], CategoryAvailabilityDto, () => [["Categories", list_type(anonRecord_type(["CategoryId", string_type], ["CategoryName", string_type]))], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["Tools", list_type(ToolAvailabilityDto_$reflection())], ["AvailableCount", int32_type], ["PartiallyAvailableCount", int32_type], ["UnavailableCount", int32_type]]);
}

export class SavedAvailabilityView extends Record {
    constructor(Name, CategoryIds, PeriodDays, ShowOnDashboard) {
        super();
        this.Name = Name;
        this.CategoryIds = CategoryIds;
        this.PeriodDays = (PeriodDays | 0);
        this.ShowOnDashboard = ShowOnDashboard;
    }
}

export function SavedAvailabilityView_$reflection() {
    return record_type("Shared.Availability.SavedAvailabilityView", [], SavedAvailabilityView, () => [["Name", string_type], ["CategoryIds", list_type(string_type)], ["PeriodDays", int32_type], ["ShowOnDashboard", bool_type]]);
}

